<template>
  <TsCard
    :appendClass="
      twMerge(
        'bg-white max-md:p-0 rounded-sm max-md:border-0 lg:border-[#DEEFFF]',
        props.appendClass
      )
    "
    noShadow
  >
    <TsTypography
      v-if="!isMobile"
      weight="semibold"
      variant="h2"
      :append-class="
        props.variant === 'messages'
          ? 'mb-2'
          : 'pb-8 lg:border-b  border-[#DEEFFF]'
      "
      data-testid="message-center-title"
    >
      {{useTranslation('AccountSideBar-MessageCenter','Berichten van Toolstation ')}}
    </TsTypography>

    <TsTitle v-if="isMobile" appendClass="mt-2 " data-testid="message-center-title-mob" :title='useTranslation("AccountSideBar-MessageCenter" , "Berichten van Toolstation")' />
    <div v-if="!props.variant">
      <TsImage
        class="mb-8 mx-auto"
        src="/images/messageCenter.png"
        width="198"
        height="184"
        loading="lazy"
        alt="no message"
      />

      <TsTypography
        variant="h4"
        weight="semibold"
        appendClass="mb-5 text-center text-idle-black"
        >{{useTranslation('AccountMessageCenter-NoNewMessages','Er zijn geen nieuwe berichte')}}</TsTypography
      >
    </div>
    <div v-else>
      <TsMedia class="flex justify-between items-center">
        <TsMediaStart>
          <TsRow appendClass="items-center m-0">
            <TsCheckbox
              :label="useTranslation('AccountMessageCenter-selectMessages','Selecteer Berichten')"
              appendClass="lg:border-r pr-3"
              :checked="isAllSelected"
              @change="toggleSelectAll"
            />
            <div v-if="isAnySelected" class="lg:pl-3">
              <TsButton
                icon="bx:message"
                outlined
                :label="useTranslation('AccountMessageCenter-markAsRead','Markeer als gelezen')"
                appendClass="max-md:hidden text-natural-grey rounded-sm  py-0.5 px-2 border-natural-light-grey mr-5"
                :data-testid="'mark-as-read-' + randomId"
                @click="handleMarkAsRead"
              />
              <TsButton
                icon="mdi:message-badge-outline"
                outlined
                :label="useTranslation('AccountMessageCenter-markAsUnread','Markeer als ongelezen')"
                appendClass="max-md:hidden  text-natural-grey rounded-sm  py-0.5 px-2 border-natural-light-grey"
                :data-testid="'mark-as-unread-' + randomId"
              />
            </div>
          </TsRow>
        </TsMediaStart>
        <TsMediaEnd>
          <TsSelectBox
            dropdown-class=""
            @select="onSelectLocale"
            input-class="block max-md:max-w-12 max-md:py-1 z-10"
            :placeholder="isMobile ? 'Date' : 'Sort by date'"
            :options="sortOptions"
            v-model="localSelectedSort"
            :data-testid="'select-box-sort-' + randomId"
          />
        </TsMediaEnd>
      </TsMedia>
    </div>
  </TsCard>
  <TsRow v-if="isMobile && isAnySelected" append-class="m-0 gap-2 justify-between mb-4">
    <TsButton
      icon="bx:message"
      outlined
      :label="useTranslation('AccountMessageCenter-markAsRead','Markeer als gelezen')"
      appendClass=" text-natural-grey rounded-sm  py-0.5 px-2 border-natural-light-grey"
      :data-testid="'mark-as-read-mobile-' + randomId"
      @click="handleMarkAsRead"
    />
    <TsButton
      icon="mdi:message-badge-outline"
      outlined
      :label="useTranslation('AccountMessageCenter-markAsUnread','Markeer als ongelezen')"
      appendClass="text-natural-grey rounded-sm py-0.5 px-2 border-natural-light-grey"
      :data-testid="'mark-as-unread-mobile-' + randomId"
    />
  </TsRow>
</template>

<script setup lang="ts">
import { twMerge } from "tailwind-merge";
import { ref, onMounted } from "vue";
import { useTranslation } from "~/composables/useTranslation";

const TsCard = defineAsyncComponent(
    () => import('~/components/organisms/TsCard.vue')
);

const TsMediaStart = defineAsyncComponent(
    () => import('~/components/organisms/TsMediaStart.vue')
);

const TsMediaEnd = defineAsyncComponent(
    () => import('~/components/organisms/TsMediaEnd.vue')
);

const TsSelectBox = defineAsyncComponent(
    () => import('~/components/atoms/TsSelectBox.vue')
);

const TsCheckbox = defineAsyncComponent(
    () => import('~/components/atoms/TsCheckbox.vue')
);

const { isMobile } = useDevice();

const sortOptions = ref([useTranslation('AccountMessageCenter-newestToOldest','Nieuwste naar oudste'), useTranslation('AccountMessageCenter-oldestToNewest','Oudste naar nieuwst')]);

type Props = {
  variant?: string;
  appendClass?: string;
  messages?: Array;
  selectedSort?: String;
  sortOptions?: Array;
  isAllSelected?: boolean;
  isAnySelected?:boolean;
  handleMarkAsRead?: (customerId: string, messageIds: Array<string>) => Promise<void>;
};

const props = withDefaults(defineProps<Props>(), {
  description: "",
  hyperLinkText: "",
  messageTime: "",
  isAllSelected: false,
  isAnySelected:false,
  handleMarkAsRead: async function (customerId: string, messageIds: Array<string>) {}
});

const randomId = ref("");

onMounted(() => {
  randomId.value = useRandomUUID();
});

const localSelectedSort = ref(props.selectedSort);
const emit = defineEmits(["update:selectedSort",'select-all']);

const stopSelectedSortWatcher = watch(
  () => props.selectedSort,
  (newSort) => {
    localSelectedSort.value = newSort;
  }
);

const stopLocalSelectedSortWatcher = watch(localSelectedSort, (newValue) => {
  emit("update:selectedSort", newValue);
});

onBeforeUnmount(() => {
  stopSelectedSortWatcher();
  stopLocalSelectedSortWatcher();
});

async function onSelectLocale(option,
    visibleOptions,
    isLoading,
    searchQuery,
    activeOptionIndex,
    dropdown) {

  dropdown.hide();
}

const toggleSelectAll = () => {
  emit('select-all');
};

</script>
